import { KoDate, KoForm, KoFormBuilder, KoSelect, CURRENCIES, KoLoader, KoTextArea, Upload, KoToast } from 'packages';
import { AssetsAPI } from 'pages/workspace/process/assets/assets.service';
import React, { useCallback, useEffect, useState } from 'react';
import styles from "./expenses.module.scss";
import { getCookie } from 'shared/utils/cookies';
import KoIcon from '@kwapio/icons';


const RecordMileageCurd = () => {
  const [form] =KoForm.useForm();

  const [isLoading, setLoading] = useState(false);
  const [customersList, setDataList] = useState();


  useEffect(() => {
    getClients();
  }, []);

  const getClients = () => {
    setLoading(true);
    AssetsAPI.getClients().then(
      (data) => {
        setLoading(false);
        setDataList(data['customers']);
      },
      (err) => {
        setLoading(false);
      }
    );
  };


  

  const Date = ({ value, onChange }) => {
    return (
      <KoDate
        value={value}
        format={'DD-MMM-YYYY'}
        daysAgo={0}
        onChange={v => onChange(v)}
      />
    );
  };


  const Currency = ({ value, onChange }) =>
    <KoSelect value={value}
      showSearch
      onChange={v => onChange(v)}
      placeholder='Select currency'
      options={CURRENCIES?.map((currency) => ({
        label: currency?.code + '-' + currency?.name,
        value: currency?.code
      }))} />;
    
  const Throught = [
    { label: 'Gay Pay', value: 'gaypay' },
    { label: 'Bank Account', value: 'bankaccount' },
    { label: 'Phone Pay', value: 'phonepay' },
    { label: 'Paytm', value: 'paytm' }
  ];

  const PaidThrough = ({ value, onChange }) =>
    <KoSelect value={value}
      onChange={v => onChange(v)}
      showSearch
      allowClear
      placeholder='Choose Paid Through'
      options={Throught?.map((value) => ({
        label: value.label,
        value: value?.value
      }))}
    />;

 


  const options = [
    { label: 'Distance travelled', value: 'distance' },
    { label: 'Odometer reading', value: 'reading' }];

  const Customers = ({ value, onChange }) =>
    <KoSelect
      value={value}
      showSearch
      mode="multiple"
      optionFilterProp="label"
      placeholder="Select customer"
      onChange={onChange}
      options={customersList?.map(cus => ({
        label: cus?.companyName || 'Unnamed Customer',
        value: cus?.customerId
      }))}
      loading={!customersList?.length}
    />;


  const report1 = [
    { label: 'quaerat', value: 'ad' },
    { label: 'et', value: 'blanditiis' }
  ];
  const report2 = [
    { label: 'soluta', value: 'soluta' },
    { label: 'adipisci', value: 'adipisci' }
  ];

  const ad = ({ value, onChange }) =>
    <KoSelect value={value}
      onChange={v => onChange(v)}
      showSearch
      allowClear
      placeholder='Select a Tax'
      options={report1?.map((value) => ({
        label: value.label,
        value: value?.value
      }))}
    />;

  const blanditiis = ({ value, onChange }) =>
    <KoSelect value={value}
      onChange={v => onChange(v)}
      showSearch
      allowClear
      placeholder='Select a Tax'
      options={report2?.map((value) => ({
        label: value.label,
        value: value?.value
      }))}
    />;

  const props = {
    name: 'files',
    multiple: true,
    action: `${process.env.REACT_APP_PROXY_HOST}/api/v1/org/upload`,
    data: { module: 'documents'},
    headers: {
      Authorization: `Bearer ${getCookie("accessToken")}`
    },
    
    onChange(info) {
      if (info.file.status !== 'uploading') {
      }
      if (info.file.status === 'done') {
        KoToast.success(`${info.file.name} file uploaded successfully`);
      } else if (info.file.status === 'error') {
        KoToast.error(`${info.file.name} file upload failed.`);
      }
    }};
    
  const normFile = (e) => {
    return e?.file;
  };
    
    
  const uploadButton = (
    <div className={styles.dndArea}>
      <KoIcon name='AttachmentOutlined' />
      <div>Record Mileages Attach File</div>
    </div>
    
  );
  const onRemoveFile = (d) => {
    console.log();
  };

  const meta = {
    columns: 4,
    formItemLayout: null,
    initialValues: {},
    colon: true,
    fields: [
      { key: 'startDate', label: 'Start Date', colSpan: 2, widget: Date },
      { key: 'ventors', label: 'Employee', placeholder:'Select a Employee', colSpan: 2, widget: Customers },
      { label:'Calculate mileage using', colSpan: 4, key: 'expensetype', widget: 'radioGroup', direction: 'horizontal',  options },
      { key: 'distance', placeholder: 'Enter the Distance', label: 'Distance' , colSpan: 2},
      { key: 'currency', label: 'Account', colSpan: 2, widget: Currency },
      { key: 'amount', placeholder: 'Enter a Amount', label: 'Amount' , colSpan: 2},
      { key: 'paidthrough', label: 'Paid Through', colSpan: 2, widget: PaidThrough },
      { key: 'ventors', label: 'Vendor', colSpan: 2, widget: Customers },
      { key: 'invoice', placeholder: 'Enter Invoice', label: 'Invoice#' , colSpan: 2},
      { key: 'description', widget: KoTextArea, label: 'Notes', colSpan: 6, placeholder: 'Enter a Notes...'},
      { key: 'customer', label: 'Customer Name', colSpan: 2, widget: Customers },
      {
        key: 'reportingtags',
        colSpan: 4,
        render() {
          return (
            <fieldset>
              <legend>Reporting Tags</legend>
            </fieldset>
          );
        }
      },
      { key: 'ad', label: 'ad', colSpan: 2, widget: ad },
      { key: 'blanditiis', label: 'blanditiis', colSpan: 2, widget: blanditiis }
    ]
  };
  const handleSubmit =useCallback((values)=>{
    console.log(values);
  },[form]);


  return (
    <div className={styles.wrapper}>
      {isLoading&& <KoLoader/>}
      <KoForm  form={form} layout="vertical" onFinish={handleSubmit} onSubmit={handleSubmit} >
        <KoForm.Item
          name={"file"}
          valuePropName={"file"}
          getValueFromEvent={normFile}>

          <Upload {...props}
            className={styles.card}
            onRemove={onRemoveFile}
            showUploadList={{showPreviewIcon : false}}
            showPreviewIcon={true}
            listType="picture-card"
          >
            {uploadButton}
          </Upload>
        </KoForm.Item>
        <KoFormBuilder form={form} meta={meta} />
      </KoForm></div>
  );
};

export default RecordMileageCurd;